import { useParams, useNavigate, useOutletContext  } from "react-router-dom";
import ModalWindow from "../ModalWindow/ModalWindow";

const ModalWindowWrapper = () => {
  const { concertId } = useParams<{ concertId: string }>();
  const navigate = useNavigate();
  const { onRefresh } = useOutletContext<{ onRefresh: () => void }>();

  if (!concertId) {
    navigate("/"); // Przekierowanie w razie braku `concertId`
    return null; // Nie renderuj komponentu
}
  const handleCloseModal = () => {
    navigate(`/concert/${concertId}`);
    onRefresh();
  };

  return (
    <ModalWindow
      onClose={handleCloseModal}
      concertId={Number(concertId)}
    />
  );
};

export default ModalWindowWrapper;
